/**
 * Logikk for AI Leader Coach
 * Analyserer leder-score og team-feedback for å generere personlig coaching.
 */

export const generateCoachingReport = (metrics) => {
  const { leadership, psychSafety, stress, conflict } = metrics;
  
  const coachingAreas = [
    {
      id: 'comm',
      title: 'Lederkommunikasjon',
      icon: 'MessageCircle',
      color: 'indigo',
      advice: leadership < 60 
        ? "Ditt team etterspør mer tydelighet. Begynn hver uke med å avklare topp 3 prioriteringer skriftlig."
        : "Du kommuniserer godt, men kan med fordel lytte mer aktivt i 1-til-1 samtaler for å fange opp uformelle signaler.",
      tips: ["Bruk 'Check-in' i starten av møter", "Vær eksplisitt på forventninger", "Del 'hvorfor' bak beslutninger"]
    },
    {
      id: 'difficult',
      title: 'Håndtering av krevende adferd',
      icon: 'UserX',
      color: 'rose',
      advice: conflict > 50
        ? "Det er tegn på uformell maktkamp. Ta tak i adferd umiddelbart fremfor å vente på neste medarbeidersamtale."
        : "Teamet virker harmonisk, men pass på at 'kunstig harmoni' ikke hindrer sunne faglige diskusjoner.",
      tips: ["Bruk I-budskap i korrigering", "Fokuser på adferd, ikke person", "Søk forståelse for bakenforliggende årsaker"]
    },
    {
      id: 'stress',
      title: 'Støtte til stressede ansatte',
      icon: 'Heart',
      color: 'orange',
      advice: stress > 65
        ? "Høyt press detektert. Din viktigste oppgave nå er å hjelpe teamet å prioritere bort 'kjekt å ha' oppgaver."
        : "Stressnivået er stabilt. Fortsett å modellere gode grenser mellom jobb og fritid.",
      tips: ["Spør: 'Hva kan jeg fjerne fra din liste?'", "Anerkjenn innsats, ikke bare resultat", "Vær oppmerksom på endret adferd"]
    },
    {
      id: 'safety',
      title: 'Bygge Psykologisk Trygghet',
      icon: 'Shield',
      color: 'emerald',
      advice: psychSafety < 50
        ? "Teamet holder igjen ideer. Du må aktivt be om motforestillinger og takke de som tør å være uenige."
        : "Du har et godt grunnlag. Utfordre teamet til å ta enda større kalkulert risiko i innovasjonsprosesser.",
      tips: ["Del egne feil og læring", "Etterspør 'sprø ideer'", "Sikre at alle stemmer blir hørt"]
    }
  ];

  const improvementPlan = [
    { step: 1, title: "Sårbarhets-modellering", desc: "Del en personlig læringshistorie i neste teammøte for å senke terskelen for andre." },
    { step: 2, title: "Prioriterings-vask", desc: "Gjennomfør en 30-minutters sesjon hvor dere kutter 20% av gjeldende oppgaver." },
    { step: 3, title: "Tydelighets-kontroll", desc: "Be teamet gjenfortelle sine viktigste mål for å sikre 100% samsvar." }
  ];

  return {
    summary: leadership < 55 
      ? "Fokusområde: Tydelighet og Tilstedeværelse. Teamet opplever usikkerhet rundt retning og forventninger."
      : "Fokusområde: Kultivering av Trygghet. Du leder godt, men kan nå skifte fokus fra drift til dypere kulturbygging.",
    coachingAreas,
    improvementPlan
  };
};